<template>
  <div id="page-user-list">
    <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      <div
        class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="$router.push('/etransport/new')">
        <feather-icon icon="GlobeIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Register New Transport</span>
      </div>
      <div
        class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
        title="Every e-Transport sent from the ERP, accepted or refused, with the ANAF answer"
        @click="logActive = true">
        <feather-icon icon="FileTextIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">LOG</span>
      </div>
    </div>
    <e-transport-log :active.sync="logActive" />
    <div class="vx-row" id="page-user-view">
      <div class="vx-col lg:w-4/4 w-full">
        <vx-card title="SPV Message" class="mb-base">
          <vs-table :data="etransportList" class="table-dark-inverted mb-base" search>
            <template slot="thead">
              <vs-th>Creation date</vs-th>
              <vs-th>Transport date</vs-th>
              <vs-th>ID SPV</vs-th>
              <vs-th>UIT</vs-th>
              <vs-th>Message</vs-th>
              <!--<vs-th>Action</vs-th>-->
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ formatDateSPV(tr.data_creare) }}</vs-td>
                <vs-td>{{ formatDateSPVSansHeure(tr.data_transp) }}</vs-td>
                <vs-td>{{ tr.id_incarcare }}</vs-td>
                <vs-td>
                  <vs-chip color="danger" v-if="tr.mesaje">
  <a :href="'https://xylo.codesinn.com/api/anaf/etransport/getxml/' + tr.uit" target="_blank" class="text-white">
    {{ tr.uit }}
  </a>
</vs-chip>
<vs-chip color="success" v-else>
  <a :href="'https://xylo.codesinn.com/api/anaf/etransport/getxml/' + tr.uit" target="_blank" class="text-white">
    {{ tr.uit }}
  </a>
</vs-chip>
                </vs-td>
                <vs-td>
                  <div v-if="tr.mesaje">
                    {{ tr.mesaje[0].tip }} :
                    {{ tr.mesaje[0].mesaj }}
                  </div>
                  <div v-else>
                    <div><b>Type</b> : <span v-if="tr.tip_op === 10">Purchase</span><span
                        v-if="tr.tip_op === 20">Sale</span></div>
                    <div><b>Transporter</b> : {{ tr.tr_den }} ({{ tr.tr_tara }})</div>
                    <div><span v-if="tr.tip_op === 10"><b>Provider</b></span><span
                        v-if="tr.tip_op === 20"><b>Client</b></span> : {{ tr.pc_den }} ({{ tr.pc_tara }})</div>
                    <div><b>Plate</b> : {{ tr.nr_veh }} / {{ tr.nr_rem1 }}</div>

                  </div>
                </vs-td>
                <!--<vs-td><feather-icon  icon="EyeIcon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /></vs-td>-->
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleBankList from '@/store/bank/moduleDataList.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import ETransportLog from './ETransportLog.vue'
import moment from 'moment'

export default {
  components: {
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    ETransportLog
  },
  data() {
    return {
      etransportList: [],
      logActive: false,
    }
  },
  computed: {
    operationsDataProcessed() {
      return this.$store.state.BankList.downloadinvoicestreated
    },
  },
  methods: {
    formatDateSPVSansHeure(dateStr) {
      if (dateStr) {
        // Utilisation de moment.js pour formater la date sans l'heure
        return moment(dateStr).format('DD/MM/YYYY');
      } else {
        return 'Format de date invalide';
      }
    },
    formatDateSPV(dateStr) {
      if (dateStr) {
        // Utilisation de moment.js pour formater la date avec l'heure
        return moment(dateStr).format('DD/MM/YYYY HH:mm:ss');
      } else {
        return 'Format de date invalide';
      }
    }
  },
  created() {
    if (!moduleBankList.isRegistered) {
      this.$store.registerModule('BankList', moduleBankList)
      moduleBankList.isRegistered = true
    }
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }

    try {
      this.$store.dispatch('BankList/getETransportList')
        .then(response => {
          this.etransportList = response.data.mesaje
          this.etransportList.sort((a, b) => {
            const dateA = moment(a.data_creare, 'YYYYMMDDHHmmss');
            const dateB = moment(b.data_creare, 'YYYYMMDDHHmmss');
            return dateB - dateA; // Trie en ordre décroissant
          });
          this.$vs.loading.close()
        })
        .catch(err => {
          this.$vs.notify({
            title: "Access Denied",
            text: "Please create a SPV TOKEN",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "bottom-center",
            time: 8000,
          });
          console.error(err)
          this.$vs.loading.close()

        })

    } catch (error) {
      console.error("Error in component created hook:", error);
    }
  },
}

</script>

<style lang="scss">
.text-white {
  color: white;
}

#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}


.context-menu {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.context-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.context-menu ul li {
  padding: 10px;
  cursor: pointer;
}

.context-menu ul li:hover {
  background-color: #f0f0f0;
}
</style>
